const showFormStyles = () => {
  document.body.style.overflowY = "hidden";

  const modalContainer = document.querySelector(".mktoModal");
  modalContainer.style.top = `${window.scrollY}px`;
  modalContainer.style.overflowY = "auto";
  modalContainer.style.height = "100%";
  modalContainer.style.background = "rgba(0,0,0,0.5)";
  modalContainer.style.zIndex = 10000;

  const intervalId = setInterval(() => {
    const modalMask = document.querySelector(".mktoModalMask");
    if (modalMask) {
      modalMask.style.height = "0px";
      // console.log("Modal mask FOUND.");

      const modalContent = document.querySelector(".mktoModalContent");
      if (modalContent) {
        modalContent.style.top = "1rem";
        // console.log("Modal content FOUND.");
      }

      clearInterval(intervalId);
    } else {
      // console.log("Modal mask not found yet.");
    }
  }, 100);

  // console.log("Modal shown!");
};

const closeFormStyles = () => {
  document.body.style.overflowY = "";
  // console.log("Modal closed!");
};

const showMktoForm = (formId) => {
  MktoForms2.loadForm("https://app-sj21.marketo.com", "316-DXP-546", formId, function (form) {
    MktoForms2.lightbox(form).show();

    showFormStyles();

    const closeButton = document.querySelector(".mktoModalClose");
    const outsideBackground = document.querySelector(".mktoModal");

    const handleCustomCloseModal = () => {
      closeFormStyles();
      closeButton.removeEventListener("click", handleCustomCloseModal);
    };

    closeButton.addEventListener("click", handleCustomCloseModal);
    outsideBackground.addEventListener("click", (event) => {
      if (event.target === outsideBackground) {
        closeButton.click();
      }
    });

    // Form is now rendered but form variable has not querySelector method, using JS to find it on the page
    const formOnDoc = document.querySelector(`#mktoForm_${formId}`); // Select the form using id
    // Focus first input
    if (formOnDoc) {
      const firstInput = formOnDoc.querySelector("input");
      firstInput.focus();
    }
  });
};

export default showMktoForm;
